import { AppState } from "store/AppState"

export const selectExampleNewsletterPatchPending = (s: AppState) =>
  s.template.exampleNewsletterPatch.pending
export const selectExampleNewsletterPatchFetchError = (s: AppState) =>
  s.template.exampleNewsletterPatch.error

export const selectExampleNewsletterPatch = (s: AppState) =>
  s.template.exampleNewsletterPatch.data || ""
